import { forwardRef } from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'

const Details = forwardRef(({ order, id }, ref) => {
  const {
    orderSubmissionResult,
    createdAt,
    stand,
    serviceType,
    seat,
    userName,
    userEmail,
    // userPhone,
  } = order

  const formatedCreatedDate = moment(createdAt)
    .local()
    .format('MM/DD/yy, h:mm A')

  return (
    <section className="order-details__section" ref={ref}>
      <div className="order-details__row" id={id}>
        <span>Order #</span>
        <span className="order-details__row--value">
          {orderSubmissionResult?.orderNumber ?? 'n/a'}
        </span>
      </div>
      <div className="order-details__row">
        <span>Created Date:</span>
        <span className="order-details__row--value">
          {formatedCreatedDate ?? 'n/a'}
        </span>
      </div>
      <div className="order-details__row">
        <span>Revenue Center:</span>
        <span className="order-details__row--value">
          {stand?.name ?? 'n/a'}
        </span>
      </div>
      <div className="order-details__row">
        <span>Service Type:</span>
        <span className="order-details__row--value">
          {serviceType ?? 'n/a'}
        </span>
      </div>
      <div className="order-details__row">
        <span>Deliver to:</span>
        <span className="order-details__row--value">
          {!isEmpty(seat)
            ? `Section ${seat?.section}, Row ${seat?.row}, Seat ${seat?.seat}`
            : 'n/a'}
        </span>
      </div>
      <div className="order-details__row">
        <span>Recipient Name:</span>
        <span className="order-details__row--value">{userName ?? 'n/a'}</span>
      </div>
      <div className="order-details__row">
        <span>Recipient Email:</span>
        <span className="order-details__row--value">{userEmail ?? 'n/a'}</span>
      </div>
      {/* <div className="order-details__row">
        <span>Recipient Phone Number:</span>
        <span>{userPhone  ?? 'n/a'}</span>
      </div> */}
    </section>
  )
})

Details.displayName = 'Details'

Details.propTypes = {
  order: PropTypes.object,
  id: PropTypes.string,
}

export default Details
